import "core-js/modules/es.array.concat.js";
export var goToSearchPage = function goToSearchPage(_ref) {
  var searchParams = _ref.searchParams,
    searchUrl = _ref.searchUrl;
  var url = "".concat(searchUrl).concat(searchParams ? "?".concat(searchParams) : '');
  window.location.assign(url);
};